import { Injectable } from '@angular/core';
import { delay } from '@helpers/delay';
import { ToastService } from '@services/_toast/_toast.service';

@Injectable({
  providedIn: 'root',
})
export class TawkService {
  constructor(private toastService: ToastService) {}

  public async showTawk() {
    if ((window as any).tawkHasLoaded !== true) {
      await delay(100);
      this.showTawk();
      return;
    }
    (window as any).Tawk_API.showWidget();
    // maximize afterwards to prevent user from having to click a second time
    (window as any).Tawk_API.maximize();
  }

  public async hideTawk() {
    if ((window as any).tawkHasLoaded !== true) {
      await delay(100);
      this.hideTawk();
      return;
    }
    // minimize first, because if the tawk widget is expanded, it wont be hidden until it is manually closed
    if (!(window as any).Tawk_API.isChatMinimized()) {
      (window as any).Tawk_API.minimize();
    }
    (window as any).Tawk_API.hideWidget();
  }

  public async setName(name: string, email: string, hash: string) {
    if ((window as any).tawkHasLoaded !== true) {
      await delay(100);
      this.setName(name, email, hash);
      return;
    }

    (window as any).Tawk_API.setAttributes(
      {
        name,
        email,
        hash,
      },
      (error: unknown) => {
        if (error) {
          this.toastService.showError(
            `An error occured setting the name of the current user in the support chat widget. Error: ${error}`
          );
          console.log(
            `An error occured setting the name of the current user in the support chat widget. Error: ${error}`
          );
        }
      }
    );
  }
}
